import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=0ea8a220&scoped=true&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"
import style0 from "./Icon.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Icon.vue?vue&type=style&index=1&id=0ea8a220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea8a220",
  null
  
)

export default component.exports